export default "__VITE_ASSET__CkPXeurU__"